import { RootState } from '@/store';
import { GetterTree } from 'vuex'
import { State } from './state'

export type RequestGetters = {
  getHospCode(state: State): String;
  getDeptCode(state:State):String;
  getAppointType(state:State):Number;
}

export const getters: GetterTree<State, RootState> & RequestGetters = {
  getHospCode: (state) => {
    return state.hospCode
  },
  getDeptCode: (state) => {
    return state.deptCode
  },
  getAppointType: (state) => {
    return state.appointType
  }
}
